<template>
  <div class="accordion" id="accordion" v-if="!update">
    <div class="message-block">
      <h2 v-if="getContents && getContents.length >= getMaxAvailablePlans && getMaxAvailablePlans !== 0">
        You can no longer create projects because you have reached the limit of your tariff plan</h2>
    </div>
    <div class="content-title">
      <h2 v-if="!isUpdate">Create New Gate</h2>
      <h2 v-else>Edit Your Gate</h2>
      <p>Fill out the required fields</p>
    </div>
    <div class="content-item">
      <h3>Content</h3>
      <div class="content-item-body">
        <form class="form-url">
          <div class="title">
            <p>Enter URL link to your offer</p>
            <div class="inputs-tooltip">
              <CustomTooltipLeft text="Link to download content"/>
            </div>
          </div>
          <div class="inputs">
            <div class="inputs-enter">
              <CustomInput @input="inputUrl"
                           :type="'url'"
                           name="text"
                           placeholder="Enter URL"
                           :pasted="page.url"
                           :invalide="!steps.content"
                           :isReq="true"
                           :isTouch="urlTouch"
                           :reqProtocols="true"
                           :required="required"/>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="content-item" style="z-index: 2">
      <h3>Design</h3>
      <div class="content-item-body">
        <form class="form-design">
          <div class="left">
            <div class="box-input">
              <label>
                <div class="title-container">
                  <span class="title">Gate title</span>
                  <span class="range">{{ page.title.length }}/{{ rules.title.max }}</span>
                </div>
                <CustomInput :max="rules.title.max" @input="inputPageTitle" type="text" name="text"
                             placeholder="Enter title" :pasted="page.title" :isReq="true"
                             :isTouch="titleTouch"
                             :required="required"/>
              </label>
              <label class="gate-description">
                <div class="title-container">
                  <span class="title">Text</span>
                  <span class="range">{{ page.description.length }}/{{ rules.text.max }}</span>
                </div>
                <textarea class="style_input" :class="{errorDesc: descTouch && !page.description.trim().length }"
                          v-model="page.description" @click="checkDesc"
                          @input="checkDesc"
                          :maxlength="rules.text.max"
                          name="description"
                          placeholder="Enter description"></textarea>
                <span class="error"
                      v-if="descTouch && !page.description.trim().length">This field is required</span>
              </label>
              <div class="box-input__upload">
                <UploadImage @cover="coverUpload" :uploadedImg="page.cover"/>
              </div>
              <div class="selects">
                <div class="select-text">
                  <span>Unlock button text</span>
                  <CustomDropdownBorder :options="buttons"
                                        :selected="selected.button"
                                        v-on:updateOption="changeButtonText"
                                        :placeholder="'Select an Item'"
                                        :closeOnOutsideClick="true"/>
                </div>
                <div class="select-scheme">
                  <span>Design scheme</span>
                  <CustomDropdownBorder :options="colorScheme"
                                        :selected="selected.colorScheme"
                                        v-on:updateOption="changeColorScheme"
                                        :placeholder="'Select an Item'"
                                        :closeOnOutsideClick="true"/>
                </div>
              </div>
            </div>
          </div>
          <div class="right_scroll">

            <div class="control" @click="sidePreviewControl">
              <span v-if="hidePreview">&larr;</span>
              <span v-else>&#10006;</span>
            </div>

            <div class="side-preview" :class="{off: hidePreview}">
              <h3>Preview</h3>
              <PostCover :page="page" :old="page.steps"/>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="content-item" style="z-index: 1">
      <h3>Gate steps</h3>
      <div class="content-item-body">
        <form class="form-gate">
          <div class="left">

            <AccordionSocial @steps="updateSteps"
                             @update_up="update_level_up($event)"
                             :blocking="page.steps.filter(v => v.status === true).length"
                             :old="page.steps"
                             :isUpdate="isUpdate"
            />
          </div>
        </form>
      </div>
    </div>
<!--    <div class="content-item">-->
<!--      <h3>Tracking pixels</h3>-->
<!--      <div class="content-item-body">-->
<!--        <form class="form-pixel">-->
<!--                <textarea v-model="pixel" @click="checkPixel" name="facebook_pixel" id="#facebook_pixel"-->
<!--                          placeholder="Enter pixels for tracking and retargeting"></textarea>-->
<!--        </form>-->
<!--      </div>-->
<!--    </div>-->
    <div class="content-item">
      <div class="content-item-title">
        <h3>Customize link</h3>
      </div>
      <CustomLink
        v-if="page"
        :tag1_prop="page.tag_1"
        :tag2_prop="page.tag_2"
        @changeTag1="changeTag1"
        @changeTag2="changeTag2"
        :errors="errors"
      />
    </div>
    <div class="content-item">
      <div class="content-item-body">
        <form class="form-confirm">
          <div class="d-flex align-items-center">
            <VueCustomTooltip :label="!checkAll || requestSent || !checkActiveSocialGate || !isValidSocialGate
                                || !page.tag_1 || !page.tag_2 || (page.tag_1.length < 5) || (page.tag_2.length < 5)
                                    ? 'Check URL, Title, Description, Steps or Custom link'
                                    : ''"
                              position="is-bottom"
                              abbreviation>
              <button class="green-btn"
                      type="submit"
                      @click.prevent="confirm"
                      :disabled="!checkAll || requestSent || !checkActiveSocialGate || !isValidSocialGate
                                || !page.tag_1 || !page.tag_2 || (page.tag_1.length < 5) || (page.tag_2.length < 5)">
                <span>Publish</span>
              </button>
            </VueCustomTooltip>
            <div class="d-flex margin-left-2">
              <LoaderMini :showMiniLoader="requestSent"
                          :failMiniLoader="errors.length > 0">
              </LoaderMini>
            </div>
          </div>
        </form>
      </div>
      <ActionModal v-if="done" :title="'Successful'" @close-n-redirect="close_n_redirect()">
        <template #body>
          <DoneBlock :url="page_prop" :custom_url="custom_url"/>
        </template>
        <template #footer>
          <button @click="close_n_redirect" class="black-border-btn">
            <span>Close</span>
          </button>
        </template>
      </ActionModal>
    </div>
  </div>
  <Preloader v-else :show-preloader="true"/>
</template>
<script>
import Vue from "vue";
import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue";
import UploadImage from "@/components/UploadImage/UploadImage.vue";
import CustomInput from "@/components/CustomInput/CustomInput.vue";
import PostCover from "@/components/PostCover/PostCover.vue";
import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue";
import CustomTooltipLeft from "@/components/CustomTooltipLeft/CustomTooltipLeft.vue";
import AccordionSocial from "@/components/AccordionSocial/AccordionSocial.vue";
import ActionModal from "@/components/modals/actionModal/ActionModal.vue";
import DoneBlock from "@/components/modals/actionModal/DoneBlock.vue";
import InfoMessage from "@/components/AlertMessage/InfoMessage.vue";
import CustomLink from "@/components/CustomLink/CustomLink.vue";
import LoaderMini from "@/components/LoaderMini/LoaderMini.vue";
import check from "@/store/helpers/helper";
import {mapGetters} from "vuex";
import Preloader from "@/components/Preloader/Preloader.vue";

export default Vue.extend({
  components: {
    Preloader,
    CustomCheckBox,
    UploadImage,
    CustomInput,
    PostCover,
    CustomDropdownBorder,
    CustomTooltipLeft,
    AccordionSocial,
    ActionModal, DoneBlock,
    InfoMessage,
    CustomLink,
    LoaderMini
  },
  props: {
    isUpdate: {type: Boolean, default: false}
  },
  data() {
    return {
      hidePreview: false,
      requestSent: false,
      checkName: false,
      required: true,
      allRight: false,
      isValidSocialGate: false,
      checkGates: {},
      rules: {
        title: {max: 150},
        text: {max: 250},
        btn_text: {max: 50}
      },
      steps: {
        name: false,
        content: false,
        design: false,
        gate: false,
        pixel: false,
        confirm: false,
      },
      buttons: [
        {id: 1, name: 'Download'},
        {id: 2, name: 'Get content'},
        {id: 3, name: 'Get link'},

      ],
      colorScheme: [
        {id: 1, name: 'Light scheme', value: false},
        {id: 2, name: 'Dark scheme', value: true}
      ],
      listBubble: [
        {name: 'Account', src: '/account'},
        {name: 'Log out', src: '/logout'},
      ],
      flag: '',
      email: '',
      projectName: '',
      page: {
        page_url: '',
        pixel: '',
        name: '',
        title: '',
        description: '',
        button: 1,
        buttonText: 'Download',
        cover: '',
        dark: false,
        url: '',
        tag_1: '',
        tag_2: '',
        steps: [
          {
            sub_id: 1,
            status: false,
            name: 'E-mail capture',
            targetType: {},
            check: {
              inputs: [],
              fillable: false,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'email',
            sort: 0,
          },
          {
            sub_id: 2,
            status: false,
            name: 'Facebook',
            targetType: {},
            actions: [{name: 'Like'}, {name: 'Share'}, {name: 'Join'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'facebook',
            sort: 0,
          },
          {
            sub_id: 3,
            status: false,
            name: 'Instagram',
            targetType: {},
            actions: [{name: 'Follow'}, {name: 'Like'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'instagram',
            sort: 0,
          },
          {
            sub_id: 4,
            status: false,
            name: 'Twitter',
            targetType: {},
            actions: [{name: 'Follow'}, {name: 'Like'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'twitter',
            sort: 0,
          },
          {
            sub_id: 6,
            status: false,
            name: 'YouTube',
            targetType: {},
            actions: [{name: 'Subscribe'}],
            check: {
              inputs: [],
              fillable: true,
              visitor: '',
              type: 'And',
              requiredOne: false,
              skippable: false
            },
            icon: 'youtube',
            sort: 0,
          },
          {
            sub_id: 8,
            status: false,
            name: 'SMS',
            targetType: {},
            check: {
              inputs: [
                {
                  id: 1,
                  account: 'sms'
                }
              ],
              fillable: false,
              visitor: '',
              type: 'And',
              requiredOne: false,
              skippable: false
            },
            icon: 'messenger',
            sort: 0,
          },
          {
            sub_id: 9,
            status: false,
            name: 'Telegram',
            targetType: {},
            check: {
              inputs: [
                {
                  id: 2,
                  account: 'tlg'
                }
              ],
              fillable: false,
              visitor: '',
              type: 'And',
              requiredOne: false,
              skippable: false
            },
            icon: 'messenger',
            sort: 0,
          },
          {
            sub_id: 10,
            status: false,
            name: 'TikTok',
            targetType: {},
            actions: [{name: 'Follow'}, {name: 'Like'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'tiktok',
            sort: 0,
          },
          {
            sub_id: 11,
            status: false,
            name: 'LinkedIn',
            targetType: {},
            actions: [{name: 'Like'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'linkedin',
            sort: 0,
          }
        ]
      },
      text: 'text',
      url: {inp: '', invalide: false, error: false},
      password: '',
      visibleB: true,
      tooltipDropdown: [
        {option: 'Profile settings', href: "/profile-settings"},
        {option: 'Logout', href: "/logout"},
      ],
      pixel: '',
      list: [],
      selected: {
        button: {id: 1, name: 'Download'},
        colorScheme: {id: 1, name: 'Light scheme', value: false}
      },
      projectNameTouch: false,
      titleTouch: false,
      urlTouch: false,
      pixelTouch: false,
      descTouch: false,
      update: false,
      done: false,
      page_prop: '',
      custom_url: '',
      errors: []
    }
  },
  methods: {
    changeTag1(data) {
      this.errors = []
      this.requestSent = false
      this.page.tag_1 = data.value
    },
    changeTag2(data) {
      this.errors = []
      this.requestSent = false
      this.page.tag_2 = data.value
    },
    update_level_up(acc) {
      let sorted = this.page.steps.filter(v => v.sub_id === acc)
      if (this.page.steps.indexOf(sorted[0]) - 1 !== -1) {
        if (!this.page.steps[this.page.steps.indexOf(sorted[0]) + 1].status) {
          this.page.steps[this.page.steps.indexOf(sorted[0]) - 1].check.type = 'And'
        } else {
          this.page.steps[this.page.steps.indexOf(sorted[0])].check.type = 'And'
        }

      }
    },
    close_n_redirect() {
      this.$router.push('/my-gates')
    },
    coverUpload(data) {
      this.page.cover = data
      this.steps.design = (this.page.description.trim() && this.page.title.trim());
    },
    sidePreviewControl() {
      this.hidePreview = !this.hidePreview
    },
    switcherFlag(flag) {
      this.flag = flag
    },
    inputEmail(data) {
      this.email = data
    },
    inputText(data) {
      this.text = data
    },
    inputUrl(data) {
      this.steps.content = !data.invalide && !data.error;
      this.url = data
      this.page.url = data.inp
    },
    inputPageTitle(data) {
      this.page.title = data.inp
      this.projectName = {inp: this.page.title, invalide: false, error: false}
      this.page.name = this.page.title
      this.steps.name = (this.page.name.length > 0)

      this.checkDesign()
    },
    checkDesc() {
      this.descTouch = true
      this.checkDesign()
    },
    checkDesign() {
      if (this.page.title.trim() && this.page.description.trim()) {
        this.steps.design = true
      } else {
        this.steps.design = false
      }
    },
    /*visibleBubble() {
      this.visibleB = !this.visibleB
    },*/
    changeColorScheme(payload) {
      this.page.dark = payload.value
    },
    changeButtonText(payload) {
      this.page.buttonText = payload.name
      this.page.button = payload.id
    },
    checkStepsGate() {
      let localFlag = false
      this.list.map(item => {
        if (this.gateIsCompleted(item)) {
          localFlag = true
        }
      })
      if (localFlag) {
        this.steps.gate = true
      } else {
        this.steps.gate = false
      }
    },
    updateSteps(payload) {
      this.list = payload
      this.checkStepsGate()
      this.page.steps = payload
      return this.page.steps
    },
    checkPixel() {
      this.pixelTouch = true
      if (this.pixel) {
        this.steps.pixel = true
      } else {
        this.steps.pixel = false
      }
    },
    getChild(name) {
      for (let child of this.$children) if (child.$options._componentTag === name) return child;
    },
    confirm() {
      if (this.allRight) {
        this.requestSent = true
        let cropperComponent = this.getChild("UploadImage");
        cropperComponent.cropImage().then((res) => {
          this.page.pixel = this.pixel
          let pageToRequest = this.page
          const data = {
            'content': pageToRequest
          }
          if (this.$route.params.id) {
            this.$store.dispatch('updateContent', data)
              .then(resp => {
                this.done = true
                this.page_prop = resp.page_url
                this.custom_url = resp.custom_url
              })
              .catch((error) => {
                this.errors = error.response.data.errors['content.tag_1']
                    ? error.response.data.errors['content.tag_1']
                    : error.response.data.errors['content.tag_2']
              })
          } else {
            this.$store.dispatch('createContent', data)
              .then(res => {
                if (res)
                  this.done = true
                  this.page_prop = res.page_url
                  this.custom_url = res.custom_url
              })
              .catch(error => {
                this.errors = error.response.data.errors['content.tag_1']
                  ? error.response.data.errors['content.tag_1']
                  : error.response.data.errors['content.tag_2']
              })

          }
        });
      }
    },
    /*prepareGatesOnRequest(gates) {
      let resultGates = [];
      gates.map(gate => {
        if (this.gateIsCompleted(gate)) {
          resultGates.push(gate)
        }
      });
      return resultGates;
    },*/
    gateIsCompleted(gate) {
      if (gate.status === true) {
        if (gate.check.inputs.length > 0 && gate.check.fillable === true) {
          gate.check.inputs.forEach(input => {
            if (input.account) {
              let res = this.checkLink(input.account, gate.icon)
              if (!this.checkGates[gate.icon]) {
                this.checkGates[gate.icon] = new Object;
              }
              this.checkGates[gate.icon][input.id] = res.isValid;
            }
          });
          if (this.checkGates[gate.icon]) {
            if (gate.check.inputs.length < Object.keys(this.checkGates[gate.icon]).length) {
              let keysId = []
              gate.check.inputs.forEach(input => {
                keysId.push(input.id.toString());
              });
              for (let key in this.checkGates[gate.icon]) {
                if (!keysId.includes(key)) {
                  delete this.checkGates[gate.icon][key];
                }
              }
            }
          }
        } else {
          this.checkGates[gate.icon] = {0: true};
        }
        this.isValidSocialGate = this.checkAllGates();
      } else {
        delete this.checkGates[gate.icon];
      }
      return (!gate.check.fillable && gate.status) || (gate.icon !== 'messenger' && gate.check.inputs.length > 0)
    },
    checkAllGates() {
      let isValid = true;
      for (let key in this.checkGates) {
        let cGate = this.checkGates[key];
        for (let id in cGate) {
          if (cGate[id] === false) {
            isValid = false;
          }
        }
      }
      return isValid;
    },

    async contentById() {
      this.update = true
      const id = this.$route.params.id
      return this.$store.dispatch('contentById', {id, full: true})
        .then(resp => {
            if (resp.status === 200) {
              setTimeout(() => {
                this.getData = true;
              }, 3000);

              const item = resp.data
              if (!item.banned) {
                this.updatePageDetails(item)
                this.sortPageSteps()
                this.projectName = {inp: item.name, invalide: false, error: false}
                this.oldName = item.page_url
                this.url = {inp: item.url, invalide: false, error: false}

                this.pixel = item.pixel

                this.selected.button = this.buttons[item.button - 1]
                this.changeButtonText(this.selected.button)

                this.selected.colorScheme = this.colorScheme[item.dark ? 1 : 0]
                this.changeColorScheme(this.colorScheme[item.dark ? 1 : 0])

                this.checkAllSteps()

                return this.page
              } else {
                this.$router.push('/not-found');
              }
            }
            if (resp.status === 404) {
              this.$router.push('/not-found');
            }
          }
        )

    },
    sortPageSteps() {
      this.page.steps = this.page.steps.sort((stepF, stepS) => {
        if (stepF.sort > stepS.sort) {
          return 1;
        }
        if (stepF.sort < stepS.sort) {
          return -1;
        }
        return 0;
      })
    },

    updatePageDetails(pageData) {
      for (let param in pageData) {
        if (param !== 'steps') {
          this.page[param] = pageData[param]
        }
      }
      this.page.steps = this.page.steps.map(step => {
        pageData.steps.forEach(itemStep => {
          if ((step.sub_id === itemStep.sub_id) && this.gateIsCompleted(itemStep)) {
            step = itemStep
            itemStep.check.inputs.forEach(input => {
              if (!this.checkGates[itemStep.icon]) {
                this.checkGates[itemStep.icon] = new Object;
              }
              this.checkGates[itemStep.icon][input.id] = true;
            });
          }
        })
        return step
      })

    },
    checkAllSteps() {
      this.checkStepsGate()
      if (this.page.name)
        this.steps.name = true
      if (this.page.url)
        this.steps.content = true
      if (this.page.title.trim() && this.page.description.trim())
        this.steps.design = true
    },
    checkLink(link, account) {
      let result = check.checkLink(link, account);
      return result;
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.contentById().then(() => {
        this.update = false
      })
    }

  },
  computed: {
    ...mapGetters(['userInfo', 'isLoggedIn', 'isActive', 'userInfo', 'getCheckingPlan', 'getPlanList', 'getActivePlanId', 'getMaxAvailablePlans', 'getContents', 'getEndTrial']),
    checkAll() {
      if (this.steps.name && this.steps.content && this.steps.design && this.steps.gate) {
        this.allRight = true
        return true
      } else {
        this.allRight = false
        return false
      }
    },
    demoSrc() {
      return this.url.inp
    },
    errorDescription() {
      return this.page.description.length < 10
    },
    checkActiveSocialGate() {
      if (Array.from(this.list).filter(v => v.status === true).length > 0) {
        return Array.from(this.list)
          .filter(v => v.status === true &&
            v.name !== 'E-mail capture' && v.name !== 'Telegram' &&
            v.name !== 'SMS' &&
            v.check.inputs
              .filter(val => val.account.length === 0).length > 0).length === 0
      } else {
        return false
      }
    }

  },
})
</script>
<style lang="sass" src="./CreateUpdateGate.sass"></style>